import clsx from 'clsx'
import Link from '@mui/material/Link'
import FactCheckIcon from '@mui/icons-material/FactCheck'
import {
    ListItemIcon, ListItemText,
} from '@mui/material'
import MenuItem from '@mui/material/MenuItem'
import Tooltip from 'app/shared-components/Tooltip'

import useCommonStyles from '../common.styles'
import useStyles from './BatchActionIcon.styles'

type Props = {
    isMenuItem?: boolean,
    onClick: () => void
    title?: string,
}

const BatchActionIcon = ({
    isMenuItem = false,
    onClick,
    title = 'Bulk Update',
}: Readonly<Props>) => {
    const {
        classes: commonClasses,
    } = useCommonStyles()
    const {
        classes,
    } = useStyles()

    if (!isMenuItem) {
        return (
            <Link
                data-testid="batch-action-btn"
                className={clsx(commonClasses.link, classes.link)}
                component="button"
                variant="body1"
                color="textSecondary"
                onClick={onClick}
            >
                <Tooltip title={title}>
                    <FactCheckIcon className={classes.icon} />
                </Tooltip>
            </Link>
        )
    }
    return (
        <MenuItem onClick={onClick}>
            <ListItemIcon>
                <FactCheckIcon className={classes.icon} />
            </ListItemIcon>
            <ListItemText primary={title} />
        </MenuItem>
    )
}

export default BatchActionIcon
